import React from "react";
import Layout from "./Layout";
import { ValidationProps } from "../../types";

interface SelectRoleProps extends ValidationProps {
	activeStep: number;
}

const SelectRole: React.FC<SelectRoleProps> = ({
	value,
	valid,
	validation,
	handleChange,
	shouldValidate,
	activeStep,
}) => {
	return (
		<Layout
			value={value}
			valid={valid}
			validation={validation}
			handleChange={handleChange}
			shouldValidate={shouldValidate}
			activeStep={activeStep}
		/>
	);
};

export default SelectRole;
